import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { PlanReference } from "../../models";
import { useData } from "../../utils/useData";
import { bulkAssignAccounts } from "../../mutations/accounts/bulkAssignAccounts";
import { checkJobProgress } from "../../utils/checkJobProgress";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig";

export const useBulkAssignAccounts = (
  employerId: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
    onBulkJobComplete?: () => void;
    successMessage?: string;
  },
) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employees, accounts } = useData();


    const onJobComplete = async () => {
        await employees.refetch();
        await accounts.refetch();
    };
    
    return useMutation(
        async ({ selectedPlan, targetEmployeeIds }: { selectedPlan: PlanReference, targetEmployeeIds: string[] }) => {
            const { API_URL, token } = await getSafeSessionConfig(config, getToken);

            let toastId = toast("Assigning Accounts...", {
                progress: 0,
                autoClose: false,
                type: "info"
            });

            var jobId = await bulkAssignAccounts(
                API_URL,
                employerId,
                token,
                selectedPlan,
                targetEmployeeIds
            )

            checkJobProgress(
                API_URL,
                jobId,
                toastId,
                "All accounts have been assigned!",
                getToken,
                onJobComplete
            );
        },
        {
            onSuccess: () => {
                toast.success("Accounts will be assigned in the background!");
                employees.refetch();
                accounts.refetch();
                options?.onSuccess?.();
            },
            onError: (error: Error) => {
                console.error(error.message);
                options?.onError?.(error);
            }
        }
    );
}


